import { c as _c } from "react/compiler-runtime";
import { Table } from '@onefootprint/ui';
import ComparisonValueDisplay from './comparison-value';
import type { ComparisonImage } from './types';
const DocumentFields = t0 => {
  const $ = _c(12);
  const {
    image,
    search
  } = t0;
  if (!image.fields.length) {
    return null;
  }
  let t1;
  if ($[0] !== image.fields || $[1] !== search) {
    let t2;
    if ($[3] !== search) {
      t2 = field_0 => field_0.key.toLocaleLowerCase().includes(search.toLocaleLowerCase());
      $[3] = search;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = image.fields.map(_temp).filter(t2);
    $[0] = image.fields;
    $[1] = search;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rows = t1;
  const t2 = `Fields for ${image.label}`;
  const t3 = `${image.label} data`;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [{
      text: "Field",
      width: "45%"
    }, {
      text: "Value",
      width: "55%"
    }];
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== rows || $[7] !== t3) {
    t5 = <Table aria-label={t3} variant="compact" hideThead={true} columns={t4} items={rows} emptyStateText="No matching fields" getKeyForRow={_temp2} getAriaLabelForRow={_temp3} renderTr={_temp4} />;
    $[6] = rows;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <div className="border-t border-tertiary"><section className="max-h-80 overflow-y-auto overscroll-contain px-3" aria-label={t2}>{t5}</section></div>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default DocumentFields;
function _temp(field, rowId) {
  return {
    ...field,
    rowId
  };
}
function _temp2(field_1) {
  return String(field_1.rowId);
}
function _temp3(field_2) {
  return field_2.key;
}
function _temp4(t0) {
  const {
    item
  } = t0;
  return <><td><span className="whitespace-normal break-words text-tertiary">{item.key}</span></td><td><div className="whitespace-normal py-1"><ComparisonValueDisplay value={item.value} /></div></td></>;
}